// TODO: Set up this list in Strapi for Product to control
const competitorEmailDomains = [
  '@draftkings.com',
  '@fanduel.com',
  '@betmgm.com',
  '@caesars.com',
  '@wynnbet.com',
  '@betrivers.com',
  '@pointsbet.com',
  '@foxbet.com',
  '@underdogsf.com',
  '@ownersbox.com',
  '@parlayplay.io',
  '@prizepicks.com',
  '@stathero.com',
  '@drafters.com',
  '@fantrax.com',
  '@bet365.com',
  '@betway.com',
  '@betfredcorporate.com',
  '@si.com',
  '@clutchbet.com',
  '@hardrocksportsbook.com',
  '@getsbk.com',
  '@betparx.com',
  '@betly.com',
  '@getsporttrade.com',
  '@betr.app',
  '@elitesportsbook.com',
  '@twinspires.com',
  '@circasports.com',
  '@drf.com',
  '@monarchblackhawk.com',
  '@qcasinodbq.com',
  '@fourwindscasino.com',
  '@firekc.com',
  '@playeagle.com',
  '@skyutecasino.com',
  '@wildwoodcasino.net',
  '@maverickgaming.com',
  '@goldennuggetcasino.com',
  '@action247.com',
  '@betjack.com',
  '@mvgrllc.com',
  '@betprophet.com',
  '@theborgata.com',
  '@tipico.us',
  '@playupusa.com',
  '@ny.ballybet.com',
  '@pa.unibet.com',
];

const leagueAffiliatedDomains = [
  '@nfl.com',
  '@mlb.com',
  '@nhl.com',
  '@nba.com',
  '@ncaa.org',
  '@pgatour.com',
  '@pgatourhq.com',
  '@fifa.org',
  '@fifa.com',
  '@wbaboxing.com',
  '@wboboxing.com',
  '@wbcboxing.com',
  '@iboboxing.com',
  '@ufc.com',
  '@mlssoccer.com',
  '@livgolf.com',
  '@powerslap.com',
  '@formula1.com',
  '@nascar.com',
  '@usta.com',
  '@itftennis.com',
  '@caasco.com',
  '@teamwass.com',
  '@wmeagency.com',
  '@excelsm.com',
  '@octagon.com',
  '@borascorp.com',
  '@rocnation.com',
  '@athletesfirst.net',
  '@klutchgroup.com',
  '@rsragency.com',
  '@premierleague.com',
  '@legaseriea.it',
  '@ifp.fr',
  '@xfl.com',
  '@iplt20.com',
  '@wwe.com',
  '@pac-12.org',
  '@sec.org',
  '@theacc.org',
  '@theamerican.org',
  '@bigten.org',
  '@big12sports.com',
  '@swac.org',
  '@nflra.com',
  '@nhlofficials.com',
  '@boxing.nv.gov',
  '@theusfl.com',
];

const blockedEmailDomains = [...competitorEmailDomains, ...leagueAffiliatedDomains];

export default blockedEmailDomains;
